import styled from 'styled-components';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'styles/helper';

export const PlayButtonContainer = styled(Stack)`
  backdrop-filter: blur(8px);
  background: ${cssVar('alpha-white-light-30')};
`;
